import styled from 'styled-components'

const Container = styled.div`
	background-color: #ffffff;
	width: 600px;
	border-radius: 5px;
	padding: 84px;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 1px 17px 30px rgba(194, 195, 199, 0.15);
	flex-direction: column;

	@media screen and (max-width: 992px) {
		width: 500px;
		padding: 60px;
	}
`

const Icon = styled.img`
	@media screen and (max-width: 600px) {
		width: 60%;
	}
`

const Heading = styled.h1`
	font-size: 50px;
	font-style: normal;
	font-weight: bold;
	color: #41364d;
	letter-spacing: 0.04em;
	text-align: center;
	@media screen and (max-width: 600px) {
		margin: 10px;
		font-size: 25px;
	}
`

const SubHeading = styled.h6`
	font-style: normal;
	font-weight: bold;
	font-size: 20px;
	text-align: center;
	color: #7c7184;
	@media screen and (max-width: 600px) {
		font-size: 12px;
	}
`

export { Heading, Icon, SubHeading, Container }
